const dropdown = document.querySelector(".js-dropdown");
const form = document.querySelectorAll(".compare-petzyo-form");
let dataTag = document.querySelector(".js-dropdown .active").getAttribute("data-food");
const listTag = document.querySelectorAll(".js-food-item");

document.querySelector(".js-food-label").addEventListener("click", (e) => {
  dropdown.classList.toggle('hide');
})

if (form) {
  form.forEach(item => {
    if (dataTag == item.getAttribute("data-tag")) {
      item.classList.add('active')
    } else {
      item.classList.add('hide')
    }
  })
}

listTag.forEach(item => {
  item.addEventListener("click", (e) => {
    listTag.forEach(item => {
      item.classList.remove('active');
    })
    item.classList.add('active');
    document.querySelector(".js-food-title .compare-petzyo__header-label").innerHTML = item.innerHTML;
    dropdown.classList.add('hide');
    dataTag = document.querySelector(".js-dropdown .active").getAttribute("data-food");
    let newUrl = location.protocol + '//' + location.host + location.pathname + '?data-food=' + dataTag;
    history.pushState({}, null, newUrl);
    if (form) {
      form.forEach(item => {
        if (dataTag == item.getAttribute("data-tag")) {
          item.classList.add('active');
          item.classList.remove('hide');
        } else {
          item.classList.add('hide');
          item.classList.remove('active')
        }
      })
    }
  })
})


// Wrap sections in a wrapper.
function wrapSections(section_class) {
  var childSections = document.querySelectorAll("."+section_class);
  if (childSections.length != 0) {
    var wrapper = document.createElement('div');
    wrapper.classList.add(section_class+"-wrapper");
    wrapper.classList.add('container');
    
    childSections.item(0).parentNode.insertBefore(wrapper, childSections.item(0));
    for ( var i=0; i< childSections.length; i++){
      wrapper.appendChild(childSections.item(i));
    }
    
  }
}
// You can call this function with a specific section class.
wrapSections("compare-internal");